<template>
  <base-layout>
    <v-row class="justify-space-between">
      <v-col md="4" cols="4">
        <v-btn outlined small color="primary" @click="$router.push({ name: 'CreateUser' })">
          <v-icon class="mr-1">mdi-account-multiple-plus</v-icon> Add
        </v-btn>
      </v-col>
      <v-col class="row" md="6" cols="8">
        <v-col md="9" cols="8">
          <v-text-field v-model="searchText" dense label="Search" @keydown.enter="searchItem"/>
        </v-col>
        <v-col md="3" class="d-flex justify-end" cols="4">
          <v-btn outlined small color="primary" @click="searchItem()">
            Find
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <paginate
      :page="parseInt(page)"
      :per-page="perPage"
      :total="total"
      @on-page-change="changePage" />
    <v-data-table
      :headers="headers"
      :items-per-page="15"
      :items="mapedData"
      :loading="loading"
      disable-sort
      hide-default-footer
      class="elevation-1">
      <template v-slot:[`item.status`]="{ item }">
        <v-switch
          color="red"
          :label="item.status"
          :value="item.status"
          v-model="item.status"
          :disabled="item.id === userId"
          true-value="active"
          false-value="inactive"
          hide-details
          @change="changeUserStatus(item, $event)"
        />
      </template>
      <template v-slot:[`item.option`]="{ item }">
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on">
              mdi-dots-vertical
            </v-icon>
          </template>
          <v-list>
            <v-list-item @click="$router.push({ name: 'UserDetail', params: { id: item.id }})">
              <v-list-item-title>Detail</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push({ name: 'UpdateUser', params: { id: item.id }})">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </base-layout>
</template>

<script>
import UserProvider from '@/resources/UserProvider'
import { mapActions } from 'vuex' 
import { getUser } from '@/utils/js/Auth'

const userService = new UserProvider()
export default {
  data: () => ({
    searchText: '',
    loading: false,
    perPage: 15,
    total: 15,
    page: 1,
    data: [],
    headers: [
      { text: 'Username', value: 'username' },
      { text: 'Name', value: 'name' },
      { text: 'E-mail', value: 'email' },
      { text: 'Status', value: 'status' },
      { text: 'Option',  align: 'center', value: 'option' }
    ]
  }),
  computed: {
    userId () {
      return getUser ? getUser().sub : ''
    },
    mapedData () {
      return this.data.map(d => ({
        id: d.id,
        username: d.username,
        name: `${d.firstName} ${d.lastName}`,
        status: d.status,
        email: d.email
      }))
    }
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    changePage (page) {
      this.page = page
      this.getData()
    },
    searchItem () {
      this.page = 1
      this.getData()
    },
    async changeUserStatus (user, value) {
      this.loading = true
      try {
        const { data } = await userService.updateUserStatus(user.id, { status: value })
        if (data) {
          this.setSnackbar({
            message: 'success',
            type: 'success',
            active: true
          })
        }
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.getData()
        this.loading = false
      }
    },
    async getData () {
      this.loading = true
      try {
        const query = `page=${this.page}&limit=${this.perPage}&search=${this.searchText}`
        const { data } = await userService.getUser(query)
        this.total = data.total
        this.data = data.results
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
